/**
 * Pure half of the export client (task T.E1) — the same framework-free rule the
 * other `*-model` modules follow: the `unit` Playwright project imports this in
 * plain Node, so nothing here may touch `fetch`, a DOM or `import.meta.env`.
 */

/** The five resources of the register; the path segment is also the file name prefix. */
export type ExportResource = 'applications' | 'venues' | 'teachers' | 'quotas' | 'online-pivot';

/** `<resource>-YYYY-MM-DD.xlsx` — the api's own naming, as a fallback when the header is absent. */
export function exportFallbackName(resource: ExportResource, now: Date = new Date()): string {
  return `${resource}-${now.toISOString().slice(0, 10)}.xlsx`;
}

/**
 * `attachment; filename="applications-2026-09-10.xlsx"; filename*=UTF-8''…` → the
 * plain name. The ASCII twin is what the file is called on disk; the RFC 5987 twin
 * is for non-ASCII names and this one never is one.
 */
export function filenameFromDisposition(header: string | null): string | null {
  if (!header) return null;
  const ascii = /filename="([^"]+)"/.exec(header)?.[1];
  return ascii ?? null;
}

/**
 * The query an export button sends for a given view — the view's own filters,
 * pagination dropped (an export is the whole filtered set; the api would 400 a
 * `page`), and `format=xlsx` stated rather than implied.
 */
export function exportParams(
  filters: Record<string, string | number | boolean | undefined>,
): Record<string, string | number | boolean | undefined> {
  return { ...filters, format: 'xlsx' };
}
